<template>
<div class="joinTeam">
  <div :class="[showFlag?'noscroll':'']">
  <div class="info" v-if="list.length>0">
    温馨提示：本应用不提供照片的长久存储功能，团体照截止时间之日起30天会自动删除，请尽早提取！
  </div>
  <div class="p32">
      <teamitem v-for="item in list" @onJointeam="onJointeam" :key="item.id" :info="item" type="joiner"></teamitem>
      <search-rule v-if="list.length===0&&!loadingTxt" :searchStatus="6" searchCot='您此时还没有参加任何团体'></search-rule>
    </div>
  </div>
  <tq v-if="showFlag"
      :team="selObj"
      @onCloseWrap="onCloseWrap"
      @onHandleInfo="onHandleInfo"
      :noops="noops"
      @onGoPhoto="onGoPhoto"></tq>
  <photo :showFlag="photoFlag"
         :collectInfo="selObj"
         @onControlPhoto="photoFlag=false"
         @onRruleDetail="photoFlag=false"></photo>
</div>
</template>

<script>
import teamitem from '@/components/teamitem'
import searchRule from '@/components/searchRule/searchRule'
import teamquestion from '@/components/teamquestion'
import photo from '@/components/photo/photo'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  data () {
    return {
      selObj: {},
      showFlag: false,
      list: [],
      noops: true,
      photoFlag: false
    }
  },
  components: {
    teamitem,
    searchRule,
    tq: teamquestion,
    photo
  },
  computed: {
    ...mapState(['loadingTxt', 'actiBol'])
  },
  deactivated () {
    this.showFlag = false
    this.photoFlag = false
  },
  activated () {
    if (!this.actiBol) {
      return
    }
    this.inimeobj()
    this.handleShare()
  },
  created () {
    this.$bus.on('jt_jointeam', this.modifyorder)
  },
  destroyed () {
    this.$bus.off('jt_jointeam')
  },
  methods: {
    ...mapMutations(['setMakePhotoInfo']),
    ...mapActions(['getjoinListA', 'addteampeopleA']),
    modifyorder (...args) {
      console.log('打回重拍')
      const [project_no, order_id] = args
      const arr = this.list.map((item) => {
        return {
          ...item,
          ...item.project_no === project_no && {
            is_back: 0,
            is_order: 1,
            order_id
          }
        }
      })
      this.list = arr
    },
    inimeobj () {
      this.meobj = {
        a: 1
      }
    },
    handleShare () {
      const { teamid } = this.$route.query
      this.queryTeam(teamid)
    },
    queryTeam (id) {
      console.log('id:::', id)
      if (id) {
        this.addteampeopleA(id).then(res => {
          this.getlist()
          this.showFlag = true
          this.selObj = res
        }).catch(() => {
          this.getlist()
        })
      } else {
        this.getlist()
      }
    },
    onJointeam (obj) {
      this.showFlag = true
      this.selObj = obj
    },
    onCloseWrap () {
      this.showFlag = false
      this.noops = true
    },
    onHandleInfo (obj) {
      const { keyname, value } = obj
      const { information = {}, extra_information } = this.selObj
      information[keyname] = value
      !value && delete information[keyname]
      const bol = extra_information.length !== Object.keys(information).length
      this.selObj.information = information
      this.noops = bol
    },
    onGoPhoto () {
      const { selObj } = this
      this.setMakePhotoInfo(selObj)
      this.photoFlag = true
      this.noops = true
      this.showFlag = false
    },
    getlist () {
      this.getjoinListA().then(res => {
        const { data } = res
        this.list = data
      })
    }
  }
}
</script>

<style scoped>
.joinTeam{
  background-color: #F5F7FA;
  box-sizing: border-box;
  min-height:100%;
}
.p32{
  padding:0 .32rem;
  box-sizing: border-box;
}
.info{
  background-color: rgba(252, 156, 29, 0.1);
  font-size: .24rem;
  color:#FC9C1D;
  box-sizing: border-box;
  padding:.16rem .4rem;
  margin-bottom: .32rem;
  line-height: .36rem;
}
.noscroll{
  position: fixed;
  width:100%;
  height:100%;
}
</style>
